<template>
  <div class='resource-arn-container'>
    <div class="resource-arn-container__text">
      {{ getResourceArn }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'ResourceArnTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getResourceArn() {
      return this.item.resourceArn;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.resource-arn-container {
  display: flex;
  align-items: center;
  &__text{
    text-transform: capitalize;
    color: var(--text-primary);
    font-size: rem(14);
    font-family: $font-family-semibold;
    line-height: 1.3em;
    width: 100%;
    padding-right: rem(10);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
  }
}
</style>
